import { LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import StyledSelect from 'app/pages/NewAccount/components/StyledSelect';
import * as _ from 'lodash';
import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
const initParamProducts: any = { limit: 50, page: 1, search: '', last: null };

const InfinitySelect = ({
  placeholder,
  onChange,
  value,
  getDataApi,
  preventApiCall,
  cachedList,
  ...props
}: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listOption, setListOption] = useState<any[]>(
    cachedList?.current ?? [],
  );
  const [isFocus, setIsFocus] = useState(false);
  const [search, setSearch] = useState('');
  const paramsProducts = useRef(initParamProducts);

  const getDataProduct = useCallback(
    async (params: { limit?: number; page: any; search?: string }) => {
      setIsLoading(true);
      try {
        if (paramsProducts.current.page > +(params.page as number)) {
          setIsLoading(false);
          return;
        }
        const { data } = await getDataApi(params);
        if (data?.paginator) {
          paramsProducts.current = {
            ...paramsProducts.current,
            last: +data?.paginator.last,
            page: +data?.paginator.current,
          };
        }
        const resData = _.isEmpty(data?.data)
          ? []
          : data?.data.map((item: any) => {
              return {
                label: item.name || item.id,
                value: item.id,
              };
            });
        setListOption(prev => Array.from(new Set([...prev, ...resData])));
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    },
    [getDataApi],
  );

  const handleSearchProduct = async paramsSearch => {
    if (!_.isEmpty(paramsSearch)) {
      setIsLoading(true);
    }
    try {
      const { data } = await getDataApi({
        limit: paramsProducts.current.limit,
        search: paramsSearch,
        page: 1,
      });
      if (data?.paginator) {
        paramsProducts.current = {
          ...paramsProducts.current,
          last: +data?.paginator.last,
          page: +data?.paginator.current,
        };
      }
      const resData = _.isEmpty(data?.data)
        ? []
        : data?.data.map((item: any) => {
            return {
              label: item.name || item.id,
              value: item.id,
            };
          });
      setListOption(resData);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = e => {
    const isEndOfList = e.target.scrollTop > (4 / 5) * e.target.scrollHeight;
    const endLoading =
      _.isNumber(paramsProducts.current.last) &&
      paramsProducts.current.page + 1 > +paramsProducts.current.last;
    if (isEndOfList && !endLoading && !isLoading) {
      getDataProduct({
        ...paramsProducts.current,
        page: paramsProducts.current.page + 1,
      });
    }
  };
  useEffect(() => {
    if (preventApiCall) return;
    getDataProduct({ limit: 50, page: 1, search: '' });
  }, [getDataProduct, preventApiCall]);
  useEffect(() => {
    if (cachedList as MutableRefObject<any[]>) {
      cachedList.current = listOption;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listOption]);

  const handleSearchDebounce = _.debounce(handleSearchProduct, 300);

  return (
    <StyledSelect
      value={value}
      suffixIcon={
        isLoading ? (
          <LoadingOutlined
            style={{
              fontSize: 20,
              color: '#1890ff',
            }}
          />
        ) : (
          <ArrowDownIcon />
        )
      }
      open={isFocus}
      placeholder={placeholder}
      onChange={e => {
        onChange(e);
      }}
      mode="multiple"
      allowClear
      onBlur={() => {
        setSearch('');
        handleSearchProduct('');
      }}
      searchValue={search}
      isFocus={isFocus}
      onSearch={e => {
        setSearch(e);
        handleSearchDebounce(e);
      }}
      onDropdownVisibleChange={setIsFocus}
      maxTagCount={'responsive'}
      options={listOption}
      dropdownStyle={{ zIndex: 4 }}
      filterOption={false}
      loading={isLoading}
      onPopupScroll={_.debounce(handleScroll, 150)}
      onClear={() => {
        setSearch('');
        handleSearchProduct('');
      }}
      {...props}
    />
  );
};

export default InfinitySelect;
